<template>
    <div>
        <h3 class="title is-3">Billing</h3>
        <hr />
        <router-view></router-view>
    </div>
</template>

<script>
export default {}
</script>
